<template>
  <div class="zoom flex-center max-width-img h-100">
    <img
      v-show="isloaded"
      v-if="barkod.length < 8"
      class="img-fluid w-100 first"
      style="max-width: 90%; max-height: 90%; height: auto"
      :src="imgcompany + ushp + '/' + barkod + '.jpeg?' + imgupdate"
      @load="onImgLoad"
    />
    <img
      v-else
      v-show="isloaded"
      class="img-fluid first"
      :src="image + barkod + '.jpeg?' + imgupdate"
      style="max-width: 90%; max-height: 90%; height: auto"
      @load="onImgLoad"
    />
    <img
      v-show="!isloaded"
      class="img-fluid first"
      style="max-width: 70%; max-height: 70%; height: auto"
      src="../assets/img/default_image.png"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["barkod", "imgupdate", "imgcompany", "ushp"],
  data() {
    return {
      isloaded: false,
    };
  },
  computed: {
    ...mapGetters(["image"]),
  },
  methods: {
    onImgLoad() {
      this.isloaded = true;
    },
  },
};
</script>
